export default __webpack_public_path__ + "static/logo-d8a3a7ab2188ed993841785e60891599.svg";